import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { PumppopuptableComponent } from '../pumppopuptable/pumppopuptable.component';
var PumpdashboardComponent = /** @class */ (function () {
    function PumpdashboardComponent(pumpservice, matDialog, ngxLoader) {
        this.pumpservice = pumpservice;
        this.matDialog = matDialog;
        this.ngxLoader = ngxLoader;
        this.pump1dplowimg = "NO";
        this.pump2dplowimg = "NO";
        this.totalWaterFlow = 0;
        this.waterLeveld = 0;
        this.pumponedp = 0;
        this.overload = 1;
        this.pumptwodp = 0;
        this.pumponestatus = 0;
        this.pumptwostatus = 0;
        this.jsonReadings = [];
        this.showTooltip = false;
        this.waterpercentage = 900;
        this.dateAray = [];
        this.lat = 21.2514; // Map center latitude
        this.lng = 81.6296; // Map center longitude
        this.markerLat = 21.2514; // Marker latitude
        this.markerLng = 81.6296; // Marker longitude
        this.markerIconUrl = 'path/to/marker-icon.png'; // Marker icon URL
        this.buchholz = 1;
        this.abswitch = 0;
        this.sumplevel = 0;
        this.selectOptions = [
            { id: "JSW-1132", name: 'JSW-1132', siteName: 'Rajkot', location: 'Gujarat' },
            { id: 'JSW-1133', name: 'JSW-1133', siteName: 'Jamnagar', location: 'Gujarat' },
            { id: 'JSW-1134', name: 'JSW-1134', siteName: 'Bhavnagar', location: 'Gujarat' }
            // Add more transformers as needed
        ];
        this.selectedpumps = [
            { name: 'pump-1' },
            { name: 'pump-2' },
            { name: 'pump-3' }
        ];
        this.graph = {
            layout: {
                title: "",
                autosize: true,
                responsive: true,
                xaxis: {
                    title: {
                        text: 'Time',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000',
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'Value',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000'
                        }
                    }
                },
                shapes: []
            },
            config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
        };
        this.graphsumplevel = {
            layout: {
                title: "",
                autosize: true,
                responsive: true,
                xaxis: {
                    title: {
                        text: 'Time',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000',
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'Value',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000'
                        }
                    }
                },
                shapes: []
            },
            config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
        };
        this.selectedpump = this.selectedpumps && this.selectedpumps.length > 0 ? this.selectedpumps[0].name : null; // Select the first pump by default
        this.selectedOption = this.selectOptions && this.selectOptions.length > 0 ? this.selectOptions[0].id : null; // Select the first transformer by default
        this.alertdata = [];
        this.totalPumpOnTimeInHours = 0;
        this.totalPumpOnTimeInMinutes = 0;
        this.totalPumpOnTimeInSeconds = 0;
        this.totalPumpOnTimeInDays = 0;
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
    }
    PumpdashboardComponent.prototype.ngOnInit = function () {
        this.ngxLoader.startLoader('dashboard');
        this.getpumpIds();
    };
    PumpdashboardComponent.prototype.getpumpIds = function () {
        var _this = this;
        var data = { "roleid": this.currentUserData.roleid, "userid": this.currentUserData.userid };
        this.pumpservice.getPumpIds(data).subscribe(function (response1) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("ksajdhgsatdashbksankdasdvasuhjdinasuhda", response1.result);
                        this.totalPumpData = response1.result;
                        if (!(response1.result.length > 0)) return [3 /*break*/, 2];
                        this.pumpIdsArray = response1.result.map(function (pump) { return pump.pump_id; });
                        this.alldata(this.pumpIdsArray);
                        return [4 /*yield*/, this.getGraphData(this.pumpIdsArray[0])];
                    case 1:
                        _a.sent();
                        this.getAlerts(this.pumpIdsArray);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    PumpdashboardComponent.prototype.alldata = function (pumpIdsArray) {
        var _this = this;
        var data = { "userid": this.currentUserData.userid, "selectedPumpId": pumpIdsArray };
        this.pumpservice.pumpdashboard(data).subscribe(function (response1) {
            _this.hasData = response1 && response1.length > 0; // Check if data exists
            console.log("response tile data", response1);
            _this.tileData = response1.tiledata;
            var pumpreadingsjson = [];
            var sumpLevels = [];
            var sdate = [];
            for (var i = response1.data.length - 1; i >= 0; i--) {
                var dataItem = response1.data[i];
                var pumpreading = JSON.parse(dataItem.pumpreadings);
                if (pumpreading && pumpreading.hasOwnProperty('Sump_Level')) {
                    sumpLevels.push(pumpreading.Sump_Level);
                    sdate.push(pumpreading.Date);
                    if (sumpLevels.length === 5) {
                        break;
                    }
                }
            }
            _this.sumpdata = sumpLevels;
            _this.sumpdate = sdate;
            var pump1readings = JSON.parse(response1.data[response1.data.length - 2].pumpreadings);
            var pump2readings = JSON.parse(response1.data[response1.data.length - 1].pumpreadings);
            _this.pumponedp = pump1readings.pumpdplow;
            _this.pumptwodp = pump2readings.pumpdplow;
            _this.pumponestatus = pump1readings.pumponffeedback;
            _this.pumptwostatus = pump2readings.pumponffeedback;
            if (pump1readings.pumpdplow == 0) {
                _this.pump1dplowimg = 'YES';
            }
            else if (pump1readings.pumpdplow == 1) {
                _this.pump1dplowimg = 'NO';
            }
            if (pump2readings.pumpdplow == 0) {
                _this.pump2dplowimg = 'YES';
            }
            else if (pump2readings.pumpdplow == 1) {
                _this.pump2dplowimg = 'NO';
            }
        });
    };
    PumpdashboardComponent.prototype.convertSecondsToTimeUnits = function (totalSeconds) {
        this.totalPumpOnTimeInDays = Math.floor(totalSeconds / 86400);
        totalSeconds %= 86400;
        this.totalPumpOnTimeInHours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        this.totalPumpOnTimeInMinutes = Math.floor(totalSeconds / 60);
        this.totalPumpOnTimeInSeconds = totalSeconds % 60;
        console.log("Total On Time:", this.totalPumpOnTimeInDays + " days, " +
            (this.totalPumpOnTimeInHours + " hours, ") +
            (this.totalPumpOnTimeInMinutes + " minutes, and ") +
            (this.totalPumpOnTimeInSeconds + " seconds"));
    };
    PumpdashboardComponent.prototype.calculatePumpOnTime = function (data) {
        var pumpOnTime = 0;
        var startTime = null;
        data.forEach(function (record) {
            // Remove extra quotation marks from the date string
            var cleanedDate = record.Date.replace(/'/g, '');
            if (record.pumponffeedback === 1) {
                if (startTime === null) {
                    startTime = new Date(cleanedDate);
                }
            }
            else {
                if (startTime !== null) {
                    var endTime = new Date(cleanedDate);
                    pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
                    startTime = null;
                }
            }
        });
        // If pump was still on at the end of the data period
        if (startTime !== null) {
            var endTime = new Date(data[data.length - 1].Date.replace(/'/g, ''));
            pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
        }
        this.convertSecondsToTimeUnits(pumpOnTime);
        return pumpOnTime;
    };
    PumpdashboardComponent.prototype.getAlerts = function (pumpid) {
        var _this = this;
        this.pumpservice.getPumpAlerts({ pumpid: pumpid }).subscribe(function (response) {
            if (response.result.length > 0) {
                _this.alertdata = response.result;
            }
            else {
                _this.ngxLoader.stopLoader('dashboard');
            }
        });
    };
    PumpdashboardComponent.prototype.sumpLevel = function (value) {
        var options = {
            series: [value],
            chart: {
                height: '100%',
                width: '100%',
                type: 'radialBar',
                offsetY: 0
            },
            title: {
                align: 'center',
                style: {
                    fontWeight: 'bold',
                    color: '#333'
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -160,
                    endAngle: 160,
                    dataLabels: {
                        name: {
                            fontSize: '70%',
                            color: '#964B00',
                            offsetY: '-5%'
                        },
                        value: {
                            offsetY: 0,
                            fontSize: '100%',
                            color: 'black',
                            formatter: function (val, opts) {
                                return val + '%';
                            }
                        }
                    }
                }
            },
            colors: ['#996633'],
            stroke: {
                dashArray: 0
            },
            labels: ['Sump Level'],
            grid: {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };
        var chart = new ApexCharts(document.querySelector("#sumpLevel"), options);
        chart.render();
    };
    PumpdashboardComponent.prototype.popupTable = function (state, selected) {
        console.log('data==edit==', state);
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '80%';
        dialogConfig.width = '70%';
        dialogConfig.data = {
            type: state,
            TransformerData: this.totalPumpData
        };
        var dialogRef = this.matDialog.open(PumppopuptableComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (response) {
        });
    };
    PumpdashboardComponent.prototype.updateSelected = function (selectedParameter) {
        this.selectedParameter = selectedParameter;
        this.createGraph();
    };
    PumpdashboardComponent.prototype.getGraphData = function (selectedpump) {
        var _this = this;
        this.jsonReadings = [];
        this.selectedpump = selectedpump;
        this.pumpservice.getSelectedPumpData({ pumpid: selectedpump }).subscribe(function (response) {
            console.log(" response.result", response.result);
            if (response.result.length > 0) {
                response.result.forEach(function (element) {
                    _this.dateAray.push(element.Timestamp);
                    _this.jsonReadings.push(JSON.parse(element.pumpreadings));
                });
                console.log(" this.jsonReadings", _this.jsonReadings);
                _this.jsonReadings.forEach(function (element) {
                    if (element.pumponffeedback == 0) {
                        element.L1 = 0;
                        element.L2 = 0;
                        element.L3 = 0;
                    }
                });
                _this.totalPumpOnTime = _this.calculatePumpOnTime(_this.jsonReadings);
                var lastIndex = _this.jsonReadings.length - 1;
                var lastReading = _this.jsonReadings[lastIndex];
                console.log(" lastreadings from graph data", lastReading);
                if (lastReading) {
                    if (lastReading.pumponffeedback == 1) {
                        _this.showcurrent = true;
                    }
                    else {
                        _this.showcurrent = false;
                    }
                    _this.abswitch = lastReading.AB_Switch_On_Feedback;
                    _this.buchholz = lastReading.Transformer_buchholz_Act;
                    _this.sumplevel = lastReading.Sump_Level;
                    _this.waterLeveld = lastReading.Water_Flow;
                    _this.overload = lastReading.overload;
                    _this.lightningTransformerFeedback = lastReading.Lighting_Transformer_On_Feedback;
                    _this.sumpLevel(_this.sumplevel);
                    //this.totalWaterFlow =  Number(_.sumBy(this.jsonReadings, (o: any) => Number(o['Water_Flow']))).toFixed(2)
                    var flowrateperminute = _this.waterLeveld / 60;
                    var flowrateoftwominutes = flowrateperminute * 2;
                    _this.totalWaterFlow = Number(flowrateoftwominutes * 720).toFixed(2);
                }
                else {
                    console.log("No valid last readings found.");
                }
                _this.updateSelected("motorrphasetemperature");
            }
        });
    };
    PumpdashboardComponent.prototype.formatTitle = function (str) {
        // Define a map of input strings to their formatted versions
        var titleMap = {
            "motorrphasetemperature": "Motor  Phase Temperature",
            "pumpcurrent": "Current",
            "motorndetemperature": "Motor Nde Temperature",
            "motordetemperature": "Motor De Temperature",
            "pumpdplow": "Pump Discharge Pressure Low",
            "overload": "Overload",
            "Water_Flow": "Water Flow",
            "Sump_Level": "Sump Level",
            "pumponffeedback": "Pump On Off Feedback"
        };
        if (titleMap.hasOwnProperty(str)) {
            return titleMap[str];
        }
    };
    PumpdashboardComponent.prototype.createGraph = function () {
        this.ngxLoader.startLoader('graphloader');
        var param = this.selectedParameter;
        this.graph.layout = {
            title: this.formatTitle(param),
            xaxis: {
                title: {
                    text: 'Time',
                    font: {
                        family: 'Arial',
                        size: 18,
                        color: '#000000',
                    }
                },
            },
            yaxis: {
                title: {
                    text: 'Value',
                    font: {
                        family: 'Arial',
                        size: 18,
                        color: '#000000'
                    }
                }
            },
        };
        var pumpCurrentArray = this.jsonReadings.map(function (pump) { return pump[param]; });
        if (param == "pumpcurrent") {
            pumpCurrentArray = this.jsonReadings.map(function (pump) { return ((pump['L1'] + pump['L2'] + pump['L3']) / 3).toFixed(2); });
        }
        if (param != 'motorrphasetemperature') {
            if (pumpCurrentArray.length === 0 || this.dateAray.length === 0) {
                this.ngxLoader.stopLoader('graphloader');
                return;
            }
            this.data = [{
                    x: this.dateAray,
                    y: pumpCurrentArray,
                    type: 'scatter',
                    text: param,
                    mode: 'lines+markers',
                    marker: { color: 'blue' }
                }];
        }
        else {
            var pumpRPhaseArray = this.jsonReadings.map(function (pump) { return pump[param]; });
            var pumpYPhaseArray = this.jsonReadings.map(function (pump) { return pump['motoryphasetemperature']; });
            var pumpBPhaseArray = this.jsonReadings.map(function (pump) { return pump['motorbphasetemperature']; });
            if (pumpRPhaseArray.length === 0 && pumpYPhaseArray.length === 0 && pumpBPhaseArray.length === 0 || this.dateAray.length === 0) {
                this.ngxLoader.stopLoader('graphloader');
                return;
            }
            this.data = [
                {
                    x: this.dateAray,
                    y: pumpRPhaseArray,
                    name: "R Phase",
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { color: 'red' }
                },
                {
                    x: this.dateAray,
                    y: pumpYPhaseArray,
                    name: "Y Phase",
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { color: 'yellow' }
                },
                {
                    x: this.dateAray,
                    y: pumpBPhaseArray,
                    name: "B Phase",
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { color: 'blue' }
                }
            ];
        }
        this.ngxLoader.stopLoader('graphloader');
        this.ngxLoader.stopLoader('dashboard');
    };
    return PumpdashboardComponent;
}());
export { PumpdashboardComponent };
